var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9266 33.7901C53.35 33.9002 53.7449 34.0996 54.0849 34.3747C54.425 34.6499 54.7023 34.9946 54.8983 35.3856C55.0943 35.7767 55.2045 36.2052 55.2214 36.6423C55.2384 37.0794 55.1618 37.5151 54.9967 37.9201C52.3767 44.2201 42.4766 48.9201 30.6666 48.9201C18.8566 48.9201 8.94665 44.2401 6.32665 37.9201C6.16152 37.5151 6.08484 37.0794 6.10179 36.6423C6.11875 36.2052 6.22891 35.7767 6.42491 35.3856C6.62092 34.9946 6.89822 34.6499 7.23827 34.3747C7.57832 34.0996 7.97324 33.9002 8.39659 33.7901C13.5309 32.5178 18.7812 31.7706 24.0666 31.5601C24.3297 31.5161 24.5989 31.5252 24.8584 31.5867C25.1179 31.6483 25.3624 31.7611 25.5776 31.9186C25.7929 32.076 25.9745 32.2749 26.1117 32.5036C26.2489 32.7323 26.339 32.9861 26.3767 33.2501C26.5667 34.7701 25.9166 36.3801 25.7766 38.0001C25.5266 40.8501 27.9666 42.3101 30.6666 42.3101C33.3766 42.3101 35.8166 40.8501 35.5666 38.0001C35.4266 36.3801 34.7767 34.7701 34.9667 33.2501C35.0043 32.9861 35.0945 32.7323 35.2317 32.5036C35.3689 32.2749 35.5504 32.076 35.7656 31.9186C35.9808 31.7611 36.2255 31.6483 36.485 31.5867C36.7445 31.5252 37.0136 31.5161 37.2766 31.5601C42.5554 31.7705 47.7991 32.5176 52.9266 33.7901Z",
    fill: "#F6DAB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1364 31.9199C36.1364 30.1699 36.1365 24.9199 30.6665 24.9199C25.1965 24.9199 25.2365 30.1299 19.1965 31.9199C14.0965 33.3999 25.1965 44.1899 30.6665 44.1899C36.1365 44.1899 47.2364 33.4199 42.1364 31.9199Z",
    fill: "url(#paint0_linear_10904_32043)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10904_32043",
    x1: 30.6665,
    y1: 44.1899,
    x2: 30.6665,
    y2: 24.9599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DAB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68673"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPimple);
export default __webpack_public_path__ + "static/media/pimple.674e2e136ffb8d385f8181170c85d3f7.svg";
export { ForwardRef as ReactComponent };